import {
  Input,
  Component,
  OnInit,
  forwardRef,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  AbstractControl
} from '@angular/forms';
import {
  NgbTooltipConfig
} from '@ng-bootstrap/ng-bootstrap';
import {
  Subscription,
  Subject,
  Observable,
  Observer
} from 'rxjs';
import {
  HttpClient
} from '@angular/common/http';

declare var $: any;

export const TEXT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputTextComponent),
  multi: true
};

@Component({
  selector: '[textInput]',
  templateUrl: 'input-text.component.html',
  providers: [TEXT_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class InputTextComponent implements ControlValueAccessor, OnInit {
  @Input() labelInput: string;
  @Input() control: AbstractControl;
  @Input() location: string;
  @Input() mandatory: boolean;
  @Input() checkFormat: boolean;
  @Input() autocomplete: string;
  @Input() name: string;
  @Input() maxLength: number = 250;
  @Input() labelClass?: string = '';
  @ViewChild('dinput') el: ElementRef;
  @Output() onModelChange: EventEmitter < string > = new EventEmitter < string > ();
  @Input() highlight: boolean = false;
  @Input() highlightLabel: string = null;
  @Input() infotext: string = null;


  _value: string;
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};
  randomId: string = this.getRandomId();

  @Input() submitPending: boolean;
  public enableObservable: Observable < boolean > ;
  private subscription: Subscription = null;
  private enableObserver: Observer < boolean > ;
  constructor(private httpService: HttpClient) {

  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
    if (!this.mandatory) {
      this.mandatory = false;
    }

    if (!this.checkFormat) {
      this.checkFormat = false;
    }
  }

  onChange(value: string) {
    this.onChangeCallback(this._value ? this._value.split('\\').join('/') : undefined);
    this.onModelChange.emit(value);
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable < boolean > (observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  writeValue(value: string): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }

  getHighlight() {
    return this.highlight ? ' highlight-border-input' : '';
  }

  setDisabledState(isDisabled: boolean): void {
    this.submitPending = isDisabled;
  }
}
